import Vue from 'vue'

import VueI18n from 'vue-i18n'
import Vuelidate from 'vuelidate'
import VueResizeText from 'vue-resize-text'

import components from './scripts/components'
import store from './scripts/store'
import registerFilters from './scripts/filters'
import localization from './scripts/localization'
import URLParamsHelper from './scripts/helpers/URLParamsHelper'

import './styles/entry.scss'

Vue.use(Vuelidate)
Vue.use(VueI18n)
Vue.use(VueResizeText)

Vue.prototype.$URLParamsHelper = new URLParamsHelper()
Vue.config.productionTip = false

registerFilters()

const i18n = new VueI18n({
  fallbackLocale: 'en',
  locale: 'en',
  messages: localization,
})

const app = new Vue({
  components,
  i18n,
  store,
})

app.$store.dispatch('runCurrentDateUpdater')

app.$mount('#app')
